// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DirectMessageBase } from './DirectMessageBase.ts'
import { CrossRateCalculationType } from '../CrossRate/CrossRateCalculationType.js'
import { DirectMessageCode } from './DirectMessageCodes.ts'

export let DirectCrossRateMessage = function (crossRateDataArray)
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_CROSS_RATE)
    this.CrossRateData = crossRateDataArray
    this.CrossRateType = CrossRateCalculationType.BID_ASK_2
}

DirectCrossRateMessage.prototype = Object.create(DirectMessageBase.prototype)